import { cleanNumberFormatter, integerFormatter } from "../../gridFormatters";

export const filesByLastUsedDefs = [
	{
		"field": "bucket",
		"headerName": "Bucket",
	},
	{
		"field": "total_size",
		"type": "numericColumn",
		"headerName": "Total Bucket Size",
		"filter": "agNumberColumnFilter",
		"cellRenderer": cleanNumberFormatter,
	},
	{
		"field": "av_count",
		"type": "numericColumn",
		"headerName": "AV Count",
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
		"cellRenderer": cleanNumberFormatter,
		"allowedAggFuncs": [
			"sum"
		]
	},
	{
		"field": "av_size",
		"type": "numericColumn",
		"headerName": "AV Size",
		"filter": "agNumberColumnFilter",
		"cellRenderer": cleanNumberFormatter,
		"aggFunc": "sum",
		"allowedAggFuncs": [
			"sum"
		],
	},
	{
		"field": "compress_count",
		"type": "numericColumn",
		"headerName": "Compress Count",
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"allowedAggFuncs": [
			"sum"
		]
	},
	{
		"field": "compress_size",
		"type": "numericColumn",
		"headerName": "Compress Size",
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
		"cellRenderer": cleanNumberFormatter,
		"allowedAggFuncs": [
			"sum"
		],
	},
	{
		"field": "custom_count",
		"type": "numericColumn",
		"headerName": "Custom Count",
		"aggFunc": "sum",
		"cellRenderer": integerFormatter,
		"filter": "agNumberColumnFilter",
		"allowedAggFuncs": [
			"sum"
		]
	},
	{
		"field": "custom_size",
		"type": "numericColumn",
		"headerName": "Custom Size",
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
		"cellRenderer": cleanNumberFormatter,
		"allowedAggFuncs": [
			"sum"
		],
	},
	{
		"field": "db_count",
		"type": "numericColumn",
		"headerName": "DB Count",
		"aggFunc": "sum",
		"cellRenderer": integerFormatter,
		"filter": "agNumberColumnFilter",
		"allowedAggFuncs": [
			"sum"
		]
	},
	{
		"field": "db_size",
		"type": "numericColumn",
		"headerName": "DB Size",
		"filter": "agNumberColumnFilter",
		"cellRenderer": cleanNumberFormatter,
		"aggFunc": "sum",
		"allowedAggFuncs": [
			"sum"
		],
	},
	{
		"field": "other_count",
		"type": "numericColumn",
		"headerName": "Other Count",
		"cellRenderer": integerFormatter,
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
		"allowedAggFuncs": [
			"sum"
		]
	},
	{
		"field": "other_size",
		"type": "numericColumn",
		"headerName": "Other Size",
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
		"cellRenderer": cleanNumberFormatter,
		"allowedAggFuncs": [
			"sum"
		],
	},
	{
		"field": "text_count",
		"type": "numericColumn",
		"headerName": "Text Count",
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"allowedAggFuncs": [
			"sum"
		]
	},
	
	{
		"field": "text_size",
		"type": "numericColumn",
		"headerName": "Text Size",
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"allowedAggFuncs": [
			"sum"
		]
	},
	// {
	// 	"field": "group_name",
	// 	"type": "numericColumn",
	// 	"headerName": "Group Name",
	// 	"aggFunc": "sum",
	// 	"filter": "agNumberColumnFilter",
	// 	"allowedAggFuncs": [
	// 		"sum"
	// 	]
	// }
];